import { render, staticRenderFns } from "./ci_catalog_badge.vue.js?vue&type=template&id=2c86d374!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_catalog_badge.vue?vue&type=template&id=2c86d374"
import script from "./ci_catalog_badge.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_catalog_badge.vue?vue&type=script&lang=js"
export * from "./ci_catalog_badge.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_catalog_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c86d374')) {
      api.createRecord('2c86d374', component.options)
    } else {
      api.reload('2c86d374', component.options)
    }
    module.hot.accept("./ci_catalog_badge.vue.js?vue&type=template&id=2c86d374!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ci_catalog_badge.vue?vue&type=template&id=2c86d374", function () {
      api.rerender('2c86d374', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue_shared/components/projects_list/ci_catalog_badge.vue"
export default component.exports